<template>
  <div>
    <Nav class="nav" />
    <router-view></router-view>
  </div>
</template>

<script>
import Nav from '@/components/admin/Nav.vue'
export default {
  components: {
    Nav
  }
}
</script>

<style scoped>
.nav{
  position: sticky;
  top: 0;
  z-index: 1001;
}
</style>
